import { controller, target } from '@github/catalyst';
import { dispatchChange } from '../util';

@controller('select-pdf-templates')
export class SelectPdfTemplatesElement extends HTMLElement {
  @target declare form: HTMLFormElement;

  selectTemplates(event: Event) {
    const target = event.target as HTMLButtonElement;
    const select = target.dataset.select as string;
    const checkboxes = Array.from(
      this.form.elements.namedItem('template') as RadioNodeList
    );
    const newValue = !checkboxes.every(
      checkbox =>
        checkbox.disabled ||
        checkbox.checked ===
          (checkbox.dataset.labels?.split(',').includes(select) ?? false)
    );
    for (const checkbox of checkboxes) {
      if (!(checkbox instanceof HTMLInputElement)) {
        throw new Error('Expected HTMLInputElement');
      }
      if (checkbox.disabled) {
        continue;
      }
      switch (select) {
        case 'all':
          checkbox.checked = true;
          break;
        case 'none':
          checkbox.checked = false;
          break;
        default:
          checkbox.checked =
            (checkbox.dataset.labels?.split(',').includes(select) ?? false) ===
            newValue;
          break;
      }
      dispatchChange(checkbox);
    }
  }

  filterTemplates(event: Event) {
    const target = event.target as HTMLButtonElement;
    const label = target.dataset.filterLabel!.toLowerCase();
    target.parentElement?.querySelectorAll('[aria-current]').forEach(el => {
      el.removeAttribute('aria-current');
    });
    target.setAttribute('aria-current', 'true');
    const checkboxes = this.form.elements.namedItem(
      'template'
    ) as RadioNodeList;
    for (const checkbox of checkboxes) {
      if (!(checkbox instanceof HTMLInputElement)) {
        throw new Error('Expected HTMLInputElement');
      }
      const visible =
        label === 'all' ||
        checkbox.dataset.labels?.toLowerCase().split(',').includes(label);
      if ((!visible && checkbox.checked) || (visible && !checkbox.checked)) {
        checkbox.checked = !checkbox.checked;
        dispatchChange(checkbox);
      }
      checkbox.closest('label')?.toggleAttribute('hidden', !visible);
    }
  }
}
